// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".shipment{padding-bottom:150px;overflow:hidden}@media(max-width:1279px){.shipment-progress-bar-wrapper{margin-top:60px}}@media(max-width:767px){.shipment-progress-bar-wrapper{margin-top:50px}}", ""]);
// Exports
module.exports = exports;
